module.exports = __webpack_public_path__ + "img/Niet of slecht verlicht.0c1ace41.png";